export class NoAuthenticationInStorage extends Error {
  constructor() {
    super(`no-authentication-in-storage`);
    Object.setPrototypeOf(this, NoAuthenticationInStorage.prototype);
  }
}
